<ng-container
  *ngIf="{ value: searchProductNumbersViewModel$ | async} as viewModel"
>
  <app-green-banner
    [title]="'i18n.lists.searchByProductNumbersModal.title'"
    [platform]="platformService?.platformType"
    [isInModal]="false"
    (closeEmitter)="goBack()"
  ></app-green-banner>

  <ion-content
    [class.touch-content]="platformService?.platformType !== platformEnum.desktop"
    scroll-y="false"
  >
    <div class="content-container">
      <app-search-bar-multi-line
        [formatSearch]="formatSearchInput"
        [platform]="platformService?.platformType"
        [placeholderSearch]="
      'i18n.lists.searchByProductNumbersModal.searchPlaceholder'
    "
        [blockFormatting]="isSearchMaxExceeded"
        (searchEmitter)="handleSearch($event)"
        (pasteEmitter)="handlePaste($event)"
        (resetSearchEmitter)="resetSearch()"
        (inputEmitter)="clearMaxCheck()"
      >
      </app-search-bar-multi-line>
      <p *ngIf="isSearchMaxExceeded" class="search-warning-message">
        {{ (numberOfProductsScrubbed === 1 ?
        'i18n.lists.searchByProductNumbersModal.maxSearchExceededSingular' :
        'i18n.lists.searchByProductNumbersModal.maxSearchExceededPlural' ) |
        translate: { numberOfProductsScrubbed: numberOfProductsScrubbed } }}
      </p>
      <div
        class="scroll-container"
        data-cy="scroll-container"
        cdkVirtualScrollingElement
      >
        <div
          *ngIf="
        searchKey === '' && !viewModel?.value?.products?.length
      "
          class="start-message"
          data-cy="start-message-container"
        >
          <p data-cy="start-message" class="bold">
            {{ 'i18n.lists.searchByProductNumbersModal.startMessage' | translate
            }}
          </p>
        </div>
        <div
          *ngIf="viewModel?.value?.isLoading"
          class="loading-spinner"
          data-cy="loading-spinner-container"
        >
          <span data-cy="loading-spinner-message" class="bold"
            >{{ 'i18n.common.loading' | translate }}...</span
          >
          <ion-spinner
            name="circles"
            data-cy="loading-spinner-icon"
          ></ion-spinner>
        </div>
        <div
          *ngIf="viewModel?.value?.showProductsFound"
          class="products-found bold"
          data-cy="products-found-message"
        >
          {{ viewModel?.value?.productsFound }}
        </div>

        <div
          *ngIf="viewModel?.value?.showProductsNotFound"
          class="products-not-found"
          data-cy="products-not-found-message"
        >
          {{ viewModel?.value?.productsNotFound }}
        </div>

        <div
          *ngIf="viewModel?.value?.showNoResultsFound"
          class="no-results-found bold"
          data-cy="no-results-found"
        >
          {{ 'i18n.lists.searchByProductNumbersModal.noResultsFound' | translate
          }}
        </div>

        <cdk-virtual-scroll-viewport
          *ngIf="viewModel?.value?.showProductsFound"
          data-cy="search-product-numbers-scroll"
          class="cdk-scroll"
          orientation="vertical"
          appCustomVs
          [itemHeights]="viewModel?.value?.itemHeights"
          [indexOffset]="0"
        >
          <app-group-product-list-desktop
            *ngIf="platformService?.platformType === platformEnum.desktop"
            [items]="viewModel?.value?.products"
            [mode]="mode"
            (selectProductCardEmitter)="selectProduct($event)"
          >
          </app-group-product-list-desktop>
          <app-group-product-list-touch
            *ngIf="platformService?.platformType !== platformEnum.desktop"
            [items]="viewModel?.value?.products"
            [mode]="mode"
            (selectProductCardEmitter)="selectProduct($event)"
          >
          </app-group-product-list-touch>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
    <ion-modal
      [isOpen]="this.addToListModalService.isModalOpen$ | async"
      (ionModalDidDismiss)="closeAndDeatachAddToListModal()"
      [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
      [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
      [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
      id="addToListModal"
    >
      <ng-template>
        <app-modal-with-nav-inline
          [rootPage]="this.addToListModalService.dualPaneRef"
          [rootPageParams]="this.addToListModalService.dualPaneModalData"
        >
        </app-modal-with-nav-inline>
      </ng-template>
    </ion-modal>
  </ion-content>

  <div
    *ngIf="viewModel?.value?.showFooter"
    class="sticky-footer"
    data-cy="sticky-footer-container"
  >
    <div class="footer-content" data-cy="sticky-footer-content">
      <div class="left-side" data-cy="sticky-footer-left-side">
        <span
          *ngIf="platformService?.platformType !== platformEnum.mobile"
          class="bold"
          data-cy="sticky-footer-num-selected"
          >{{ (viewModel?.value?.numberOfProductsSelected) }}&nbsp;{{
          ((viewModel?.value?.numberOfProductsSelected) > 1 ?
          'i18n.lists.products' : 'i18n.lists.product') | translate }} &nbsp;{{
          'i18n.lists.selected' | translate }}
        </span>
        <ng-container
          *ngIf="viewModel?.value?.numberOfProductsFound > viewModel?.value?.numberOfProductsSelected"
        >
          <div
            *ngIf="platformService?.platformType !== platformEnum.mobile"
            class="separator"
            data-cy="separator-image"
            src="assets/images/divider-white.svg"
          ></div>
          <span
            class="select-all"
            [class.select-all-mobile]="platformService?.platformType === platformEnum.mobile"
            (click)="selectAll()"
            data-cy="sticky-footer-select-all"
            >{{ 'i18n.common.selectAll' | translate }}</span
          >
        </ng-container>

        <div
          *ngIf="platformService?.platformType !== platformEnum.mobile"
          class="separator"
          data-cy="separator-image"
          src="assets/images/divider-white.svg"
        ></div>
        <span
          class="deselect-all"
          (click)="deselectAll()"
          data-cy="sticky-footer-deselect-all"
          >{{ 'i18n.common.deselectAll' | translate }}</span
        >
      </div>
      <div class="right-side" data-cy="sticky-footer-right-side">
        <ion-button
          class="usf-outline-green-button"
          data-cy="sticky-footer-submit-btn"
          (click)="openAddToListModal(viewModel?.value)"
        >
          {{ viewModel?.value?.submitBtnText }}<ion-icon
            data-cy="submit-btn-detail-icon"
            name="chevron-forward-outline"
          ></ion-icon
        ></ion-button>
      </div>
    </div>
  </div>
</ng-container>
